// src/sections/About.js
import React from "react";
import "./About.css";
import prMark from "../assets/about/PR.png";

export default function About() {

  return (
    <section className="about" id="about" aria-label="About">
      {/* Background watermark */}
      <img className="about__bgMark" src={prMark} alt="" aria-hidden="true" />

      <div className="about__wrap">
        <div className="about__content">
          <div className="about__kicker">About</div>

          <h2 className="about__title">
            Senior Computer Engineer. Product-led, cloud-native execution.
          </h2>

          <p className="about__text">
            Computer Engineer with <strong>4+ years of development experience</strong>,
            currently working at {" "} <strong>Google Cloud Platform (GCP)</strong>.
          </p>

          <p className="about__text">
            My background spans <strong>frontend, backend, and cloud infrastructure</strong>,
            with a focus on delivering production-ready systems — from architecture and APIs to{" "}
            deployment, monitoring, and scaling.
          </p>

          <p className="about__text">
            Outside of my role at Google, I build and ship <strong>end-to-end software products</strong>{" "}
            as a freelancer. Owning the full lifecycle allows me to move fast, reduce
            complexity, and deliver solutions that are both technically solid and business-aware.
          </p>

          <div className="about__highlights" aria-label="Highlights">
            <div className="aboutPill">Full-Stack + UX</div>
            <div className="aboutPill">Backend + APIs</div>
            <div className="aboutPill">Cloud Architecture</div>
            <div className="aboutPill">Product Ownership</div>
          </div>

          {/* <div className="about__ctaRow">
            <button className="btn btn--primary" onClick={() => scrollTo("contact")}>
              Work with me
            </button>

            <button className="btn btn--ghost" onClick={() => scrollTo("projects")}>
              See projects
            </button>
          </div> */}
        </div>
      </div>
    </section>
  );
}
